var _path, _g, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_17079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3791C0 23.4531 6.547 30.0001 14.621 30.0001C22.696 30.0001 29.243 23.4531 29.243 15.3791C29.243 7.30408 22.696 0.75708 14.621 0.75708C6.547 0.75708 0 7.30408 0 15.3791Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_17079)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3791C0 23.4531 6.547 30.0001 14.621 30.0001C22.696 30.0001 29.243 23.4531 29.243 15.3791C29.243 7.30408 22.696 0.75708 14.621 0.75708C6.547 0.75708 0 7.30408 0 15.3791Z",
    fill: "url(#paint0_linear_0_17079)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90592 8.13501C10.8119 8.13501 11.5449 8.87001 11.5449 9.77301C11.5449 10.678 10.8119 11.414 9.90592 11.414C8.99792 11.414 8.26392 10.678 8.26392 9.77301C8.26392 8.87001 8.99792 8.13501 9.90592 8.13501ZM8.48992 21.753H11.3219V12.656H8.48992V21.753Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0957 12.6554H15.8077V13.8994H15.8447C16.2237 13.1834 17.1457 12.4304 18.5227 12.4304C21.3857 12.4304 21.9137 14.3134 21.9137 16.7634V21.7524H19.0877V17.3294C19.0877 16.2734 19.0667 14.9174 17.6177 14.9174C16.1467 14.9174 15.9217 16.0664 15.9217 17.2524V21.7524H13.0957V12.6554Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_17079",
    x1: 14.6214,
    y1: -5.29908,
    x2: -6.05638,
    y2: 15.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.275b40a1.svg";
export { ForwardRef as ReactComponent };